import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class SensorMappingStore {
  sensor_data = [];
  sensor_mapping = [];
  sensorMappingData = [];
  total = 0;
  loading = false;

  constructor() {
    makeObservable(this, {
      sensor_data: observable,
      sensor_mapping: observable,
      total: observable,
      loading: observable,
      sensorMappingData: observable,
      addData: action,
      loadData: action,
    });
  }

  async sensorCodecData(){
    
    const response = await postApi
      .getClient()
      .get(config.NodeUrl + "/sensorMapping/getSensorCodecData");
      // .get("http://localhost:4000/sensorMapping/getSensorCodecData");

    this.sensor_data = response?.data?.data?.sensorData;
    this.sensor_mapping =  response?.data?.data?.sensorMappingData;

    return {
      sensor_data: this.sensor_data,
      sensor_mapping: this.sensor_mapping,
    };

  }

  async addData(postdata) {

    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/sensorMapping/saveMappingData",
        // "http://localhost:4000/sensorMapping/saveMappingData",
        postdata
      );
   
    return response;
  }

  async deleteRecord(postdata) {

    var response = await postApi
      .getClient("")
      .post(
        config.NodeUrl + "/sensorMapping/deleteMappingData",
        // "http://localhost:4000/sensorMapping/deleteMappingData",
        postdata
      );
   
    return response;
  }

  async loadData({ companyId, offset, limit, sensorMappingId }) {

    this.loading = true;

    var postData = { 
      companyId: companyId, 
      offset: offset,
      limit: limit,
      sensorMappingId: sensorMappingId
    };

    var response = await postApi
      .getClient("")
      .get(config.NodeUrl + "/sensorMapping/getSensorMappingData", { params: postData });
      // .get("http://localhost:4000/sensorMapping/getSensorMappingData", { params: postData });

    this.total = response?.data?.totalCount;
    this.sensorMappingData = response?.data?.data;
    this.loading = false;

    return response?.data

  }

}

export default SensorMappingStore;
